/* eslint-disable camelcase */
import * as React from 'react';
import { AvatarBadge } from 'components/Avatar';
import { reachabilityStyles, ReachabilityInfo } from 'components/ReachabilityBadge';
import { CoinColor } from 'components/Coin';
import { GlyphName } from '@remind/r101-glyphs';

export type Props = {
  hoverable?: boolean;
  reachability?: ReachabilityInfo;
};

function AvatarReachabilityBadge(props: Props) {
  const { reachability } = props;

  if (!reachability) {
    return null;
  }

  const { status, reasonShort, reason_short } = reachability;

  const styles = reachabilityStyles[status];

  if (!styles) {
    console.error('AvatarReachabilityBadge tried to get styles for nonexistent status');
    return null;
  }

  return (
    <AvatarBadge
      tooltipCopy={props.hoverable ? reasonShort || reason_short : null}
      backgroundColor={styles.backgroundColor as CoinColor}
      iconColor="white"
      iconName={styles.iconName as GlyphName}
    />
  );
}

export default AvatarReachabilityBadge;
